import { z } from 'zod'

export const AccountGroupByTypeSchema = z.enum(['owner', 'status'])
export type AccountGroupByType = z.infer<typeof AccountGroupByTypeSchema>
export const ACCOUNT_GROUP_BY_TYPES = AccountGroupByTypeSchema.options

export const AccountGroupByOptionSchema = z.enum(['none', ...ACCOUNT_GROUP_BY_TYPES])
export type AccountGroupByOption = z.infer<typeof AccountGroupByOptionSchema>
export const ACCOUNT_GROUP_BY_OPTIONS = AccountGroupByOptionSchema.options
